import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import {
   destinationData,
   originData,
   tonnageData,
   vehicleCategoryData,
} from "../../../../constansts/LocalData";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import {
   addAdhocLaneAsync,
   fetchAdhocLaneAsync,
   resetLane,
} from "../../../../redux/features/adhocLaneSlice";
import toast from "react-hot-toast";
import RouteNames from "../../../../AppRoutes/RouteName";
import { Checkbox, FormControlLabel } from "@mui/material";
import { getService } from "../../../../Api/services";
import EndUrls from "../../../../Api/endUrls";

const phoneRegExp =
   /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
const allowNumberAndDecimals = /^\d*\.?\d*$/;

const validationSchema = yup.object().shape({
   customerName: yup.string().required("Customer name is required."),
   origin: yup.string().required("Origin is required."),
   destination: yup.string().required("Destination is requried."),
   materialCustomerOrigin: yup.object().shape({
      customerName: yup.string().required("Customer name is required."),
      contactPersonName: yup.string().required("Contact person name is required"),
      contactPersonNo: yup
         .string()
         .required("Contact person number is required.")
         .matches(phoneRegExp, "Invalid mobile number."),
   }),
   materialCustomerDesitnation: yup.object().shape({
      customerName: yup.string().required("Customer name is required."),
      contactPersonName: yup.string().required("Contact person name is required"),
      contactPersonNo: yup
         .string()
         .required("Contact person number is required.")
         .matches(phoneRegExp, "Invalid mobile number."),
   }),
   materialDescription: yup.string(),
   tonnage: yup.string().required("Tonnage is required."),
   tripRate: yup
      .string()
      .required("Trip rate is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   brokerageCharge: yup
      .string()
      .required("Brokerage charge is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   miscCharge: yup
      .string()
      .required("Misc charge is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   destinationRate: yup
      .string()
      .required("Destination rate is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   laneName: yup.string().required("Lane name is required."),
   driverTripAdvance: yup
      .string()
      .required("Driver trip advance is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   tripDiselBudget: yup
      .string()
      .required("Trip disel budget is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   tripAdblueBudget: yup
      .string()
      .required("Trip adblue is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   tripToll: yup
      .string()
      .required("Trip toll is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   vichleType: yup.string().required("Vichle type is required."),
   tat: yup
      .string()
      .required("Tat is required.")
      .matches(allowNumberAndDecimals, "Invalid input."),
   otherRemarks: yup.string().required("Other Remarks is required"),
});

const AdhocLaneAdd = (props) => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [searchParams, setSearchParams] = useSearchParams();
   const [selectFromList, setSelectFromList] = useState(false);
   const [adhocLaneOptions, setAdhocLaneOptions] = useState([]);
   console.log({ selectFromList });

   const locationData = useSelector((state) => state.fleetMaster.location);
   const singleLaneData = useSelector((state) => state.adhocLane.singleLane);

   const initial = {
      customerName: "",
      origin: [],
      destination: "",
      materialCustomerOrigin: {
         customerName: "",
         contactPersonName: "",
         contactPersonNo: "",
      },
      materialCustomerDesitnation: {
         customerName: "",
         contactPersonName: "",
         contactPersonNo: "",
      },
      materialDescription: "",
      tonnage: "",
      tripRate: "",
      brokerageCharge: "",
      miscCharge: "",
      destinationRate: "",
      laneName: "",
      driverTripAdvance: "",
      tripDiselBudget: "",
      tripAdblueBudget: "",
      tripToll: "",
      vichleType: "",
      tat: "",
      otherRemarks: "",
   };

   const fetchUniqueAdhocLaneList = async () => {
      try {
         const res = await getService(EndUrls.getUniqueAdhocLaneList, true);
         setAdhocLaneOptions(
            res?.data?.data?.map?.((item) => ({
               value: item?.id,
               label: item?.customername,
            }))
         );
      } catch (error) {}
   };

   const handleSelectLaneName = async (data) => {
      const laneId = data?.[0]?.value;
      try {
         const res = await getService(EndUrls.getAdhocLaneById(laneId), true);

         setFieldValue("customerName", res?.data?.data?.customername || "");
         setFieldValue("origin", res?.data?.data?.origin || "");
         setFieldValue("destination", res?.data?.data?.destination || "");

         setFieldValue(
            "materialCustomerOrigin.customerName",
            res?.data?.data?.material_customer_name_origin || ""
         );
         setFieldValue(
            "materialCustomerOrigin.contactPersonName",
            res?.data?.data?.material_contact_person_name_origin || ""
         );
         setFieldValue(
            "materialCustomerOrigin.contactPersonNo",
            res?.data?.data?.material_contact_person_no_origin || ""
         );

         setFieldValue(
            "materialCustomerDesitnation.customerName",
            res?.data?.data?.material_customer_name_destination || ""
         );
         setFieldValue(
            "materialCustomerDesitnation.contactPersonName",
            res?.data?.data?.material_contact_person_name_destination || ""
         );
         setFieldValue(
            "materialCustomerDesitnation.contactPersonNo",
            res?.data?.data?.material_contact_person_no_destination || ""
         );

         setFieldValue(
            "materialDescription",
            res?.data?.data?.material_description_details || ""
         );
      } catch (error) {}
   };

   useEffect(() => {
      if (locationData?.length === 0 || !locationData) {
         dispatch(getFleetMasterDropdownDataAsync());
      }
   }, [locationData]);

   const handleAddhocLaneAdd = async (values) => {
      const payload = {
         model_id: "2",
         action_id: "3",
         origin: values?.origin,
         destination: values?.destination,
         material_customer_name_origin: values?.materialCustomerOrigin?.customerName,
         material_contact_person_name_origin:
            values?.materialCustomerOrigin?.contactPersonName,
         material_contact_person_no_origin:
            values?.materialCustomerOrigin?.contactPersonNo,
         material_customer_name_destination:
            values?.materialCustomerDesitnation?.customerName,
         material_contact_person_name_destination:
            values?.materialCustomerDesitnation?.contactPersonName,
         material_contact_person_no_destination:
            values?.materialCustomerDesitnation?.contactPersonNo,
         material_destination_details: values?.materialDescription,
         customername: values?.customerName,
         tonnage: values?.tonnage,
         rate: values?.tripRate,
         lane_name: values?.laneName,
         brokerage_charge: values?.brokerageCharge,
         misc_charge: values?.miscCharge,
         detention_rate: values?.destinationRate,
         driver_trip_advance: values?.driverTripAdvance,
         tripdiesel_budget: values?.tripDiselBudget,
         trip_adblue_budget: values?.tripAdblueBudget,
         trip_toll: values?.tripToll,
         vehicle_type: values?.vichleType,
         tat: values?.tat,
         remarks: values?.otherRemarks,
      };

      dispatch(backdropLoadingAction(true));
      dispatch(
         addAdhocLaneAsync({
            data: payload,
            err: () => {
               dispatch(backdropLoadingAction(false));
               toast.error("Something went wrong !");
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               navigate(RouteNames.adhocLaneView, { state: { from: "add-adhoc-lane" } });
               toast.success("Record added successfully !");
            },
         })
      );
   };

   useEffect(() => {
      fetchUniqueAdhocLaneList();
   }, []);

   const formik = useFormik({
      initialValues: initial,
      validationSchema: validationSchema,
      onSubmit: handleAddhocLaneAdd,
   });

   const { errors, touched, getFieldProps, handleSubmit, setFieldValue, resetForm } =
      formik;
   return (
      <div>
         <BodyHeader title="Add AdHoc Lane & Customer " />
         {/* <form className="p-3 shadow-lg" onSubmit={formik.handleSubmit}> */}
         <FormikProvider value={formik}>
            <div className="p-5 shadow-lg">
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Customer Documents</h3>
                  </div>
                  <div className="card-body">
                     <FormControlLabel
                        control={<Checkbox />}
                        label="Select from list"
                        onChange={(e) => {
                           setSelectFromList(e.target?.checked);
                           resetForm();
                        }}
                     />
                     <div className="row">
                        <div className="col-lg-4">
                           {selectFromList ? (
                              <CustomDropdown
                                 require
                                 label="Customer Name"
                                 id="customerNameSelect"
                                 // name="customerName"
                                 optionData={adhocLaneOptions}
                                 onChange={handleSelectLaneName}
                                 errors={
                                    Boolean(touched.customerName) &&
                                    Boolean(errors.customerName)
                                 }
                                 message={errors.customerName}
                              />
                           ) : (
                              <CustomInput
                                 require
                                 label="Customer Name"
                                 id="customerName"
                                 name="customerName"
                                 placeholder="Enter Customer Name"
                                 {...getFieldProps("customerName")}
                                 errors={
                                    Boolean(touched.customerName) &&
                                    Boolean(errors.customerName)
                                 }
                                 message={errors.customerName}
                              />
                           )}
                        </div>
                        <div className="col-lg-4">
                           <CustomDropdown
                              label="Origin"
                              require
                              id="origin"
                              name="origin"
                              optionData={locationData}
                              labelField={"name"}
                              valueField={"id"}
                              disabled={selectFromList}
                              // {...getFieldProps("origin")}
                              values={locationData?.filter?.(
                                 (item) => item?.id == getFieldProps("origin").value
                              )}
                              onChange={(value) => {
                                 setFieldValue("origin", value[0]?.id);
                              }}
                              errors={Boolean(touched.origin) && Boolean(errors.origin)}
                              message={errors.origin}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomDropdown
                              require
                              label="Destination"
                              disabled={selectFromList}
                              id="destination"
                              optionData={locationData}
                              labelField={"name"}
                              valueField={"id"}
                              values={locationData?.filter?.(
                                 (item) => item?.id == getFieldProps("destination").value
                              )}
                              onChange={(value) => {
                                 setFieldValue("destination", value[0]?.id);
                              }}
                              errors={
                                 Boolean(touched.destination) &&
                                 Boolean(errors.destination)
                              }
                              message={errors.destination}
                           />
                        </div>

                        {/* Contact Person Details  */}
                        <div className="col-lg-12">
                           <div className="row">
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Material customer name (Origin)"
                                    id="mcno"
                                    disabled={selectFromList}
                                    name="mcno"
                                    placeholder="Enter Customer Name"
                                    {...getFieldProps(
                                       "materialCustomerOrigin.customerName"
                                    )}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerOrigin?.customerName
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerOrigin?.customerName
                                       )
                                    }
                                    message={errors.materialCustomerOrigin?.customerName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Contact Person Name"
                                    id="cpno"
                                    disabled={selectFromList}
                                    name="cpno"
                                    placeholder="Enter Contact Person Name"
                                    {...getFieldProps(
                                       "materialCustomerOrigin.contactPersonName"
                                    )}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerOrigin
                                             ?.contactPersonName
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerOrigin?.contactPersonName
                                       )
                                    }
                                    message={
                                       errors.materialCustomerOrigin?.contactPersonName
                                    }
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Contact Person Mobile No"
                                    disabled={selectFromList}
                                    id="cpnmno"
                                    name="cpnmno"
                                    placeholder="Enter Contact Person Mobile No"
                                    {...getFieldProps(
                                       "materialCustomerOrigin.contactPersonNo"
                                    )}
                                    maxLength={10}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerOrigin?.contactPersonNo
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerOrigin?.contactPersonNo
                                       )
                                    }
                                    message={
                                       errors.materialCustomerOrigin?.contactPersonNo
                                    }
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Material costomer name (Destination)"
                                    id="mcnd"
                                    disabled={selectFromList}
                                    name="mcnd"
                                    placeholder="Enter Material costomer name (Destination)"
                                    {...getFieldProps(
                                       "materialCustomerDesitnation.customerName"
                                    )}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerDesitnation
                                             ?.customerName
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerDesitnation?.customerName
                                       )
                                    }
                                    message={
                                       errors.materialCustomerDesitnation?.customerName
                                    }
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Contact Person Name"
                                    id="cpnd"
                                    disabled={selectFromList}
                                    name="cpnd"
                                    placeholder="Enter Contact Person Name"
                                    {...getFieldProps(
                                       "materialCustomerDesitnation.contactPersonName"
                                    )}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerDesitnation
                                             ?.contactPersonName
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerDesitnation
                                             ?.contactPersonName
                                       )
                                    }
                                    message={
                                       errors.materialCustomerDesitnation
                                          ?.contactPersonName
                                    }
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    label="Contact Person Mobile No"
                                    id="cpmnd"
                                    disabled={selectFromList}
                                    name="cpmnd"
                                    placeholder="Enter Contact Person Mobile No"
                                    maxLength={10}
                                    {...getFieldProps(
                                       "materialCustomerDesitnation.contactPersonNo"
                                    )}
                                    errors={
                                       Boolean(
                                          touched.materialCustomerDesitnation
                                             ?.contactPersonNo
                                       ) &&
                                       Boolean(
                                          errors.materialCustomerDesitnation
                                             ?.contactPersonNo
                                       )
                                    }
                                    message={
                                       errors.materialCustomerDesitnation?.contactPersonNo
                                    }
                                 />
                              </div>
                              <div className="col-lg-12">
                                 <CustomTextArea
                                    label="Material description details"
                                    id="mdd"
                                    disabled={selectFromList}
                                    placeholder="Enter Description"
                                    {...getFieldProps("materialDescription")}
                                    errors={
                                       Boolean(touched.materialDescription) &&
                                       Boolean(errors.materialDescription)
                                    }
                                    message={errors.materialDescription}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomDropdown
                                    label="Tonnage"
                                    require
                                    optionData={tonnageData}
                                    values={tonnageData?.filter?.(
                                       (item) =>
                                          item?.value == getFieldProps("tonnage").value
                                    )}
                                    onChange={(value) => {
                                       formik.setFieldValue("tonnage", value[0]?.value);
                                    }}
                                    errors={
                                       Boolean(touched.tonnage) && Boolean(errors.tonnage)
                                    }
                                    message={errors.tonnage}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="trip_rate"
                                    name="trip_rate"
                                    label="Trip Rate"
                                    placeholder="Enter Trip Rate"
                                    {...getFieldProps("tripRate")}
                                    errors={
                                       Boolean(touched.tripRate) &&
                                       Boolean(errors.tripRate)
                                    }
                                    message={errors.tripRate}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="bc"
                                    label="Brokerage charge"
                                    placeholder="Enter Brokerage charge"
                                    {...getFieldProps("brokerageCharge")}
                                    errors={
                                       Boolean(touched.brokerageCharge) &&
                                       Boolean(errors.brokerageCharge)
                                    }
                                    message={errors.brokerageCharge}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="msc"
                                    label="Misc Charge"
                                    placeholder="Enter Misc Charge"
                                    {...getFieldProps("miscCharge")}
                                    errors={
                                       Boolean(touched.miscCharge) &&
                                       Boolean(errors.miscCharge)
                                    }
                                    message={errors.miscCharge}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="dr"
                                    label="Detention rate"
                                    placeholder="Enter Detention rate"
                                    {...getFieldProps("destinationRate")}
                                    errors={
                                       Boolean(touched.destinationRate) &&
                                       Boolean(errors.destinationRate)
                                    }
                                    message={errors.destinationRate}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="ln"
                                    label="Lane Name"
                                    placeholder="Enter Lane Name"
                                    {...getFieldProps("laneName")}
                                    errors={
                                       Boolean(touched.laneName) &&
                                       Boolean(errors.laneName)
                                    }
                                    message={errors.laneName}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="driver_trip_advance"
                                    name="driver_trip_advance"
                                    label="Driver Trip Advance"
                                    placeholder="Enter Driver Trip Advance"
                                    {...getFieldProps("driverTripAdvance")}
                                    errors={
                                       Boolean(touched.driverTripAdvance) &&
                                       Boolean(errors.driverTripAdvance)
                                    }
                                    message={errors.driverTripAdvance}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="trip_diesel_budget"
                                    name="trip_diesel_budget"
                                    label="Trip Diesel budget (ltr)"
                                    placeholder="Enter Trip Diesel budget (ltr)"
                                    {...getFieldProps("tripDiselBudget")}
                                    errors={
                                       Boolean(touched.tripDiselBudget) &&
                                       Boolean(errors.tripDiselBudget)
                                    }
                                    message={errors.tripDiselBudget}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="trip_adblue_budget"
                                    name="trip_adblue_budget"
                                    label="Trip Adblue budget (ltr)"
                                    placeholder="Enter Trip Adblue budget (ltr)"
                                    {...getFieldProps("tripAdblueBudget")}
                                    errors={
                                       Boolean(touched.tripAdblueBudget) &&
                                       Boolean(errors.tripAdblueBudget)
                                    }
                                    message={errors.tripAdblueBudget}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="trip_toll"
                                    name="trip_toll"
                                    label="Trip Toll"
                                    placeholder="Enter Trip Toll"
                                    {...getFieldProps("tripToll")}
                                    errors={
                                       Boolean(touched.tripToll) &&
                                       Boolean(errors.tripToll)
                                    }
                                    message={errors.tripToll}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomDropdown
                                    require
                                    label="Vehicle Type"
                                    optionData={vehicleCategoryData}
                                    values={vehicleCategoryData?.filter?.(
                                       (item) =>
                                          item?.value == getFieldProps("vichleType").value
                                    )}
                                    onChange={(value) => {
                                       formik.setFieldValue(
                                          "vichleType",
                                          value[0]?.value
                                       );
                                    }}
                                    errors={
                                       Boolean(touched.vichleType) &&
                                       Boolean(errors.vichleType)
                                    }
                                    message={errors.vichleType}
                                 />
                              </div>
                              <div className="col-lg-4">
                                 <CustomInput
                                    require
                                    id="tat"
                                    name="tat"
                                    label="TAT (in Hrs)"
                                    placeholder="Enter TAT (in Hrs)"
                                    {...getFieldProps("tat")}
                                    errors={Boolean(touched.tat) && Boolean(errors.tat)}
                                    message={errors.tat}
                                 />
                              </div>
                              <div className="col-lg-12">
                                 <CustomTextArea
                                    label="Other Remarks"
                                    id="otherRemarks"
                                    placeholder="Other Remarks"
                                    {...getFieldProps("otherRemarks")}
                                    errors={
                                       Boolean(touched.otherRemarks) &&
                                       Boolean(errors.otherRemarks)
                                    }
                                    message={errors.otherRemarks}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-12 mt-3 text-center mt-4">
                  <button
                     className="btn btn-primary px-4 py-3"
                     type="button"
                     onClick={handleSubmit}
                  >
                     <h6 className="mb-0 text-uppercase">Submit</h6>
                  </button>
                  <button
                     className="btn btn-danger ml-3 px-4 py-3"
                     type="button"
                     onClick={resetForm}
                     disabled={singleLaneData ? true : false}
                  >
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button>
               </div>
            </div>
         </FormikProvider>
      </div>
   );
};

export default AdhocLaneAdd;
